export const clearDataForLogout = () => {
    sessionStorage.clear();
    pendo.clearSession?.(); // Optional chaining to avoid error if pendo is not initialized
};
